import { createI18n } from '@learnforge/i18n';
import { locales, type DemoKey } from './locales';

export const i18n = createI18n<DemoKey>({
  gameId: '3d-geometry',
  locales,
});

export type { DemoKey };
